import * as React from 'react'
import styled from 'styled-components'

import Modal from '../../ui/Modal/Modal'
import TncModalBackground from '../../../assets/img/tnc-modal-background.png'
import { TncTitle, TncDescription } from '../TermsAndConditions/TnCContent'

import media from '../../../services/generateMediaQueries'
import ActionButton from '../../ui/ActionButton/ActionButton'

const StyledModal = styled(Modal)`
  max-width: 480px !important;
  background: center / cover no-repeat url('${TncModalBackground}'), #ffffff !important;

  ${media.lessThan('small')`
    max-width: 100%;
    border-radius: 0;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 40px);
  padding: 40px;

  ${media.lessThan('small')`
    max-height: 100vh;
    width: 100vw;
  `}
`

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  text-align: center;
  margin: 0;
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: var(--color-primary);
`

const Content = styled.div`
  flex-shrink: 1;
  font-size: 0.875rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 1rem;
  margin-right: -1rem;
  line-height: 2;

  &::-webkit-scrollbar {
    border-radius: 0.5rem;
    width: 0.5rem;
    background-color: #ebebeb;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: var(--color-primary);
  }
`

const AgreeButton = styled(ActionButton)`
  margin-top: 1.25rem;
  padding: 1rem 2rem;
`

function TncModal({ show, zIndex, onClose, onAgree }) {
  return (
    <StyledModal
      id="tncModal"
      zIndex={zIndex}
      show={show}
      hasCloseButton={!onAgree}
      handleClose={e => {
        e.stopPropagation()
        onClose(e)
      }}
    >
      <Container>
        <Title>
          <TncTitle />
        </Title>
        <Content>
          <TncDescription />
        </Content>
        {onAgree && (
          <AgreeButton variant="primary" onClick={onAgree}>
            I Agree
          </AgreeButton>
        )}
      </Container>
    </StyledModal>
  )
}

export default TncModal
